const buildtimeConfig: WebpackAppConfig =
  require("../_configs/configs") as WebpackAppConfig;

export function getConfig(): CommonAppConfig {
  return buildtimeConfig;
}
